import { Pie } from 'vue-chartjs';
import { ChartLabels } from 'chartjs-plugin-labels'; //For Pie Charts Only
import { ChartDataLabels } from 'chartjs-plugin-datalabels'; //For Horizontal Bar Only

Chart.defaults.pie.defaultFontSize = 11;
Chart.defaults.global.defaultFontColor='black';

export default {
  extends: Pie,
  props: ['data', 'options'],
  plugins: ['chart-labels', 'chartjs-plugin-datalabels'],
  components: { ChartLabels, ChartDataLabels },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.data, {
    legend: {
      display: true,
      position: 'right',
      labels: {
        font: 10
      }
    },
    title: {
      display: false,
      // text: 'Top 10 holdings for Existing Portfolio'
    },
    tooltips: { enabled: false },
    hover: { mode: null },
    show_as_html: true,
    plugins:
    {
      labels: [
        {
         render: 'percentage',
         position: 'outside'
        },
        // {
        //   render: 'percentage'
        // }
      ],
      datalabels: {
        color: '#000000',
        font: {
          size: 10,
          family: "'Helvetica', 'Arial'"
        },
        formatter: function () {
          return "";
        },
      },
    }
    });
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Charts/PieChart.js